import React, { Suspense } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";

import Sidebar from "components/sidebar";
import { memberRoutes } from "routes.js";

export default function Member(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Member Dashboard");

  // responsive sidebar toggle
  React.useEffect(() => {
    const handleResize = () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    const route = memberRoutes.find(r => 
      location.pathname.includes(r.path)
    );
    if (route) setCurrentRoute(route.name);
  }, [location.pathname]);

  const getActiveNavbar = (routes) => {
    const route = routes.find(r => location.pathname.includes(r.path));
    return route ? route.secondary : false;
  };

  const renderRoutes = (routes) => {
    const flatRoutes = [];
    routes.forEach((prop, key) => {
      if (prop.layout === "/member") {
        if (prop.path === "dashboard") {
          flatRoutes.push(
            <Route path="dashboard" element={<prop.component />} key={`${key}-dash`} />,
            <Route path="dashboard/:uuid" element={<prop.component />} key={`${key}-uuid`} />
          );
        } else {
          flatRoutes.push(
            <Route path={prop.path} element={<prop.component />} key={key} />
          );
        }
      }
    });
    return flatRoutes;
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      {/* Sidebar */}
      <Sidebar open={open} onClose={() => setOpen(false)} routes={memberRoutes} />

      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-gray-50 dark:!bg-navy-900">
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          <div className="h-full">
            {/* Navbar */}
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Horizon UI Tailwind React"}
              brandText={currentRoute}
              secondary={getActiveNavbar(memberRoutes)}
              {...rest}
            />

            {/* Page Routes */}
            <div className="mx-auto mb-auto h-full min-h-[84vh] pt-5 px-2 md:pr-2">
              <Suspense fallback={<div className="flex h-full items-center justify-center"><div className="text-xl font-medium text-navy-700 dark:text-white">Loading...</div></div>}>
                <Routes>
                  {renderRoutes(memberRoutes)}

                  {/* default redirect */}
                  <Route
                    path="/"
                    element={<Navigate to="/member/dashboard" replace />}
                  />
                </Routes>
              </Suspense>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
